import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Grid, Typography } from "@mui/material";
import { wines} from "../Home/Wines/wineData";
import style from "./Detail.module.css";
import Footer from "../Home/Footer/Footer";
import Banner from "../Home/Banner/Banner";

function Detail() {
  const { id } = useParams();
  const [t] = useTranslation("global");
  const wine = wines.find((wine) => wine.id === id);
  const otherWines = wines.filter((wine) => wine.id !== id);
 
  if (!wine) return <div className={style["lds-dual-ring"]}></div>;

const {
  name,
  type,
  price,
  cont,
  stock,
  alcoholVol,
  descriptionEN,
  descriptionES,
  temp,
  noseEN,
  noseES,
  colorEN,
  colorES,
  mouthEN,
  mouthES,
  pairingEN,
  pairingES,
  image,
  amazonUrl,
  fallbackAmazonUrl,
  mercadoLibreUrl,
} = wine;



return (
  <>
    <Grid
      container
      alignItems="center"
      sx={{ textAlign: { xs: "center", md: "left" } }}
      justifyContent="center"
      className={style.container}
    >
    <Grid item xs={12} sm={12} md={4}>
    <img
      src={image}
      alt={`${name} wine`}
      style={{ height: 460, objectFit: "contain" }}
    />
  </Grid>

      <Grid item xs={12} sm={12} md={8}>
        <Grid container alignItems="center" justifyContent="center">
          <Grid item xs={12} sm={12} md={6}>
            <Typography
              component="h1"
              sx={{
                fontSize: "3.5rem",
                fontFamily: "var(--font-title)",
              }}
            >
              {name}
            </Typography>

            <Typography
              component="h3"
              sx={{
                fontSize: "2rem",
                color: "var(--color-blue)",
                fontFamily: "var(--font-text)",
              }}
            >
              {type}
            </Typography>

            <Typography
              component="h3"
              gutterBottom
              sx={{
                fontSize: "2rem",
                color: "var(--color-blue)",
                fontFamily: "var(--font-text)",
              }}
            >
              ${price} | {cont} mL
            </Typography>

            <Typography
              component="p"
              sx={{
                fontSize: "1.5rem",
                marginBottom: "1em",
                fontFamily: "var(--font-text)",
                lineHeight: 1.7,
              }}
            >
              {t("component.language") === "EN"
                ? descriptionEN
                : descriptionES}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <Typography
              component="h3"
              gutterBottom
              sx={{
                fontSize: "1.8rem",
                fontFamily: "var(--font-text)",
                textTransform: "uppercase",
              }}
            >
              {`${stock}` === "0"
                ? `${t("component.out")}`
                : `${stock} ${t("component.available")}`}
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
                alignItems: { xs: "center", md: "flex-start" },
                marginBottom: "2rem",
              }}
            >
              <a
                href={amazonUrl || fallbackAmazonUrl}
                target="_blank"
                rel="noreferrer"
                className={style.btn_link}
              >
                <button className={style.wine_btn}>
                  {t("component.language") === "EN" ? "Buy On Amazon" : "Comprar en Amazon"}
                </button>
              </a>

              <a
                href={mercadoLibreUrl}
                target="_blank"
                rel="noreferrer"
                className={style.btn_link}
              >
                <button className={style.wine_btn}>
                  {t("component.language") === "EN"
                    ? "Buy on Mercado Libre"
                    : "Comprar en Mercado Libre"}
                </button>
              </a>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <Typography
              component="h2"
              sx={{
                fontSize: "1.5rem",
                color: "var(--color-blue)",
                fontFamily: "var(--font-text)",
              }}
            >
              Color:
            </Typography>

            <Typography
              component="h2"
              gutterBottom
              sx={{
                fontSize: "1.5rem",
                marginBottom: "1em",
                fontFamily: "var(--font-text)",
              }}
            >
              {t("component.language") === "EN" ? colorEN : colorES}
            </Typography>

            <Typography
              component="h2"
              sx={{
                fontSize: "1.5rem",
                color: "var(--color-blue)",
                fontFamily: "var(--font-text)",
              }}
            >
              {t("component.nose")}:
            </Typography>

            <Typography
              component="h2"
              gutterBottom
              sx={{
                fontSize: "1.5rem",
                marginBottom: "1em",
                fontFamily: "var(--font-text)",
              }}
            >
              {t("component.language") === "EN" ? noseEN : noseES}
            </Typography>

            <Typography
              component="h2"
              sx={{
                fontSize: "1.5rem",
                color: "var(--color-blue)",
                fontFamily: "var(--font-text)",
              }}
            >
              {t("component.mouth")}:
            </Typography>

            <Typography
              component="h2"
              gutterBottom
              sx={{
                fontSize: "1.5rem",
                marginBottom: "1em",
                fontFamily: "var(--font-text)",
              }}
            >
              {t("component.language") === "EN" ? mouthEN : mouthES}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <Typography
              component="h2"
              gutterBottom
              sx={{
                fontSize: "1.5rem",
                marginBottom: "1em",
                fontFamily: "var(--font-text)",
              }}
            >
              {alcoholVol} Alc. Vol.
            </Typography>

            <Typography
              component="h2"
              sx={{
                fontSize: "1.5rem",
                color: "var(--color-blue)",
                fontFamily: "var(--font-text)",
              }}
            >
              {t("component.pairing")}:
            </Typography>

            <Typography
              component="h2"
              gutterBottom
              sx={{
                fontSize: "1.5rem",
                marginBottom: "1em",
                fontFamily: "var(--font-text)",
              }}
            >
              {t("component.language") === "EN" ? pairingEN : pairingES}
            </Typography>

            <Typography
              component="h2"
              sx={{
                fontSize: "1.5rem",
                color: "var(--color-blue)",
                fontFamily: "var(--font-text)",
              }}
            >
              {t("component.temp")}:
            </Typography>

            <Typography
              component="h2"
              gutterBottom
              sx={{
                fontSize: "1.5rem",
                marginBottom: "1em",
                fontFamily: "var(--font-text)",
              }}
            >
              {temp}°C
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>

    <Banner />

    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(30rem, 1fr))",
        justifyContent: "center",
        justifyItems: "center",
        alignItems: "center",
        rowGap: "4rem",
        padding: "0 6rem",
        marginBottom: "4rem",
      }}
    >
      <Typography
        component="h2"
        sx={{
          gridColumn: "1/-1",
          justifySelf: "start",
          fontSize: "4rem",
          color: "var(--color-blue)",
          fontFamily: "var(--font-title)",
          marginBottom: "3rem",
        }}
      >
        {t("component.itMayInterestYou")}
      </Typography>

      {otherWines.map((wine) => (
        <Box
          key={wine.id}
          component="figure"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "2rem",
            padding: "2rem 0",
            transition: "all 0.5s",
            "&:hover": {
              boxShadow: "0 5px 10px black",
              transform: "translateY(-1rem)",
            },
          }}
        >
          <Link to={`/detail/${wine.id}`} className={style.detail_name}>
            <Typography
              component="span"
              sx={{
                color: "var(--color-text-light)",
                fontSize: "2rem",
                transition: "all 0.3s",
                "&:hover": {
                  color: "var(--color-blue)",
                },
              }}
            >
              {wine.name}
            </Typography>
          </Link>

          <Link to={`/detail/${wine.id}`}>
            <img
              src={wine.image}
              alt={wine.name}
              className={style.wine_img}
            />
          </Link>

          <Link to={`/detail/${wine.id}`} className={style.detail_btn}>
            {t("component.viewDetail")}
          </Link>
        </Box>
      ))}
    </Box>

    <Footer />
  </>
);
}
export default Detail;
